import React from 'react';
import classNames from 'classnames';
import { CONTACTS_NAMELESS_LETTER } from '../types/ContactDisplay';

const LETTERS = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ', CONTACTS_NAMELESS_LETTER];

interface ContactsAlphabetIndexProps {
  availableLetters: Set<string>;
  activeLetter: string | null;
  onSelect: (letter: string) => void;
}

const ContactsAlphabetIndex: React.FC<ContactsAlphabetIndexProps> = ({ availableLetters, activeLetter, onSelect }) => (
  <nav className="contacts__index" aria-label="Index alphabétique">
    {LETTERS.map((letter) => {
      const isAvailable = availableLetters.has(letter);
      return (
        <button
          key={letter}
          type="button"
          className={classNames('contacts__index-letter', {
            'contacts__index-letter--disabled': !isAvailable,
            'contacts__index-letter--active': letter === activeLetter,
          })}
          aria-current={letter === activeLetter ? 'true' : undefined}
          disabled={!isAvailable}
          onClick={() => onSelect(letter)}
        >
          {letter}
        </button>
      );
    })}
  </nav>
);

export default ContactsAlphabetIndex;
